module.exports = __webpack_public_path__ + "img/Certificate_7.fbdeed05.jpg";